import User from './User.js';

/**
 * Экземпляр пользователя для централизованного доступа к методам аутентификации.
 * @type {User}
 */
const user = new User();

/**
 * Экспортируемый объект пользователя для использования в других частях приложения.
 */
export default user;